import { LoadingIndicator } from '@bambi/component-library/src/components/LoadingIndicator/LoadingIndicator';
import { useMemo } from 'react';

import { GeolocationEmptyState } from '../GeolocationEmptyState';
import { columns } from './columns';
import { usePaginatedGeolocationSearchResults } from './GeolocationSearch';
import { DataGrid } from 'src/common/DataGrid';

export function GeolocationsDataGrid() {
  const {
    geolocationsListQueryState,
    searchIsActive,
    pagination,
    handlePaginationChange,
  } = usePaginatedGeolocationSearchResults({ enableArchived: true });

  const { geolocations, totalCount, isLoading, isFetching } =
    geolocationsListQueryState;

  const emptyState = useMemo(() => {
    return <GeolocationEmptyState searchIsActive={searchIsActive} />;
  }, [searchIsActive]);

  if (isLoading || isFetching) {
    return (
      <div className="my-72 flex justify-center">
        <LoadingIndicator />
      </div>
    );
  }

  return (
    <>
      <div>
        <DataGrid
          tableId="geolocation-management"
          dataTestId="geolocation-management-table"
          columns={columns}
          data={geolocations}
          pagination={pagination}
          totalCount={totalCount}
          handlePaginationChange={handlePaginationChange}
          emptyState={emptyState}
          getRowId={(row) => row.id}
        />
      </div>
    </>
  );
}
